{
  "version": 1,
  "source": {
    "image": "docs/reference/cornelis-anthonisz-1538.jpg",
    "width": 2000,
    "height": 1454
  },
  "method": {
    "stepPx": 2,
    "minPixels": 500,
    "vesselMaxLightness": 28,
    "candidates": ["ijWater", "riverWater", "canalWater"]
  },
  "bodies": {
    "ij": {
      "kind": "ij",
      "class": "ijWater",
      "pixels": 100101,
      "vesselPixels": 50872,
      "votes": {
        "ijWater": 86334,
        "riverWater": 129,
        "canalWater": 13638
      }
    },
    "damrak": {
      "kind": "area",
      "class": "ijWater",
      "pixels": 5308,
      "vesselPixels": 3278,
      "votes": {
        "ijWater": 2832,
        "riverWater": 3,
        "canalWater": 2473
      }
    },
    "diemermeer": {
      "kind": "area",
      "class": "ijWater",
      "pixels": 0,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "buikslotermeer": {
      "kind": "area",
      "class": "ijWater",
      "pixels": 0,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "broekermeer": {
      "kind": "area",
      "class": "ijWater",
      "pixels": 0,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "braak": {
      "kind": "area",
      "class": "ijWater",
      "pixels": 0,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "oude-nonnenvaart": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 0,
      "vesselPixels": 11,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "nieuwe-nonnensloot": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 2,
      "vesselPixels": 6,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 2
      },
      "fallback": "kind"
    },
    "spoey-east": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 1,
      "vesselPixels": 26,
      "votes": {
        "ijWater": 1,
        "riverWater": 0,
        "canalWater": 0
      },
      "borrowedFrom": "oudezijds-voorburgwal"
    },
    "kattengat-north": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 0,
      "vesselPixels": 11,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "kattengat-south": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 0,
      "vesselPixels": 5,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "singel": {
      "kind": "moat",
      "class": "canalWater",
      "pixels": 914,
      "vesselPixels": 1002,
      "votes": {
        "ijWater": 168,
        "riverWater": 41,
        "canalWater": 705
      }
    },
    "kloveniersburgwal": {
      "kind": "moat",
      "class": "canalWater",
      "pixels": 1056,
      "vesselPixels": 317,
      "votes": {
        "ijWater": 142,
        "riverWater": 0,
        "canalWater": 914
      }
    },
    "geldersekade": {
      "kind": "moat",
      "class": "canalWater",
      "pixels": 109,
      "vesselPixels": 699,
      "votes": {
        "ijWater": 72,
        "riverWater": 0,
        "canalWater": 37
      },
      "fallback": "kind"
    },
    "nieuwmarkt-moat": {
      "kind": "moat",
      "class": "canalWater",
      "pixels": 145,
      "vesselPixels": 208,
      "votes": {
        "ijWater": 21,
        "riverWater": 0,
        "canalWater": 124
      },
      "borrowedFrom": "kloveniersburgwal"
    },
    "oudezijds-voorburgwal": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 762,
      "vesselPixels": 1014,
      "votes": {
        "ijWater": 191,
        "riverWater": 0,
        "canalWater": 571
      }
    },
    "oudezijds-achterburgwal": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 64,
      "vesselPixels": 853,
      "votes": {
        "ijWater": 48,
        "riverWater": 0,
        "canalWater": 16
      },
      "borrowedFrom": "oudezijds-voorburgwal"
    },
    "grimburgwal": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 13,
      "vesselPixels": 20,
      "votes": {
        "ijWater": 6,
        "riverWater": 0,
        "canalWater": 7
      },
      "borrowedFrom": "oudezijds-voorburgwal"
    },
    "oudezijds-kolk": {
      "kind": "harbour",
      "class": "canalWater",
      "pixels": 4,
      "vesselPixels": 275,
      "votes": {
        "ijWater": 3,
        "riverWater": 0,
        "canalWater": 1
      },
      "borrowedFrom": "oudezijds-voorburgwal"
    },
    "rokin": {
      "kind": "river",
      "class": "canalWater",
      "pixels": 232,
      "vesselPixels": 83,
      "votes": {
        "ijWater": 6,
        "riverWater": 0,
        "canalWater": 226
      },
      "borrowedFrom": "amstel"
    },
    "rokin-north": {
      "kind": "river",
      "class": "canalWater",
      "pixels": 1184,
      "vesselPixels": 522,
      "votes": {
        "ijWater": 120,
        "riverWater": 0,
        "canalWater": 1064
      }
    },
    "amstel": {
      "kind": "river",
      "class": "canalWater",
      "pixels": 2251,
      "vesselPixels": 156,
      "votes": {
        "ijWater": 13,
        "riverWater": 1004,
        "canalWater": 1234
      }
    },
    "oudeschans": {
      "kind": "moat",
      "class": "canalWater",
      "pixels": 861,
      "vesselPixels": 503,
      "votes": {
        "ijWater": 262,
        "riverWater": 199,
        "canalWater": 400
      }
    },
    "zwanenburgwal": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 583,
      "vesselPixels": 82,
      "votes": {
        "ijWater": 25,
        "riverWater": 195,
        "canalWater": 363
      }
    },
    "recht-boomssloot": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 83,
      "vesselPixels": 143,
      "votes": {
        "ijWater": 35,
        "riverWater": 13,
        "canalWater": 35
      },
      "borrowedFrom": "oudeschans"
    },
    "krom-boomssloot": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 37,
      "vesselPixels": 61,
      "votes": {
        "ijWater": 23,
        "riverWater": 0,
        "canalWater": 14
      },
      "fallback": "kind"
    },
    "nieuwezijds-voorburgwal": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 514,
      "vesselPixels": 915,
      "votes": {
        "ijWater": 129,
        "riverWater": 4,
        "canalWater": 381
      }
    },
    "nieuwezijds-achterburgwal": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 309,
      "vesselPixels": 473,
      "votes": {
        "ijWater": 84,
        "riverWater": 0,
        "canalWater": 225
      },
      "borrowedFrom": "nieuwezijds-voorburgwal"
    },
    "spui": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 26,
      "vesselPixels": 143,
      "votes": {
        "ijWater": 5,
        "riverWater": 0,
        "canalWater": 21
      },
      "borrowedFrom": "rokin-north"
    },
    "martelaarsgracht": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 41,
      "vesselPixels": 86,
      "votes": {
        "ijWater": 19,
        "riverWater": 0,
        "canalWater": 22
      },
      "borrowedFrom": "nieuwezijds-voorburgwal"
    },
    "raamsloot": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 2,
      "vesselPixels": 12,
      "votes": {
        "ijWater": 1,
        "riverWater": 0,
        "canalWater": 1
      },
      "borrowedFrom": "kloveniersburgwal"
    },
    "begijnensloot": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 1,
      "vesselPixels": 41,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 1
      },
      "borrowedFrom": "nieuwezijds-voorburgwal"
    },
    "kartuizerwetering": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 2,
      "vesselPixels": 24,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 2
      },
      "borrowedFrom": "singel"
    },
    "kostverlorenvaart": {
      "kind": "canal",
      "class": "canalWater",
      "pixels": 2,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 2,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "schinkel": {
      "kind": "river",
      "class": "riverWater",
      "pixels": 4,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 2,
        "riverWater": 2,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "boerenwetering": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 2,
      "vesselPixels": 1,
      "votes": {
        "ijWater": 0,
        "riverWater": 1,
        "canalWater": 1
      },
      "fallback": "kind"
    },
    "gaasp": {
      "kind": "river",
      "class": "riverWater",
      "pixels": 0,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "zaan": {
      "kind": "river",
      "class": "riverWater",
      "pixels": 0,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    },
    "leprozenhuis-moat": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 5,
      "vesselPixels": 2,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 5
      },
      "fallback": "kind"
    },
    "kartuizers-moat": {
      "kind": "ditch",
      "class": "canalWater",
      "pixels": 0,
      "vesselPixels": 0,
      "votes": {
        "ijWater": 0,
        "riverWater": 0,
        "canalWater": 0
      },
      "fallback": "kind"
    }
  }
}
